import { render, staticRenderFns } from "./CooperativeAgents.vue?vue&type=template&id=1fbe62ae&"
import script from "./CooperativeAgents.vue?vue&type=script&lang=js&"
export * from "./CooperativeAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports